/**
 *
 * @author Matthew Rawson @ 15/02/2018 09:11
 * @description
 * @notes
 */
import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import PropTypes from "prop-types"
import {get, set} from "lodash"
import styled from "styled-components"

import id from "@irati/utils/id"
import {ValidationButtonRouterLink} from "@irati/ui/src/Link"
import Form from "@irati/ui/src/Form"
import {Card} from "@irati/ui/src/Layout"

import {
  QuestionCount,
  IncludeDriverComment,
  DriverCommentTitle,
  IncludeENPS,
  Reference,
  IncludeActionBoard,
  ActionBoardUrl,
  Status,
  TeamsIds,
  Tenant
} from "@irati-web/fields/survey"
import {PROPERTY as TEAMS_ID_PROPERTY} from "@irati-web/fields/survey/preferences/TeamIds"
import {PROPERTY as INCLUDE_DRIVER_COMMENT_PROPERTY} from "@irati-web/fields/survey/preferences/IncludeDriverComment"
import {PROPERTY as INCLUDE_ACTION_BOARD_PROPERTY} from "@irati-web/fields/survey/preferences/IncludeActionBoard"
import Confirm from "@irati/ui/src/Confirm"


const StyledCard = styled(Card)`
  margin-bottom: 30px;
`


class SurveyForm extends Component {
  static propTypes = {
    survey: PropTypes.object,
    onSubmit: PropTypes.func.isRequired
  };
  static defaultProps = {
    survey: {}
  };


  constructor(props) {
    super(props)
    this.state = {
      survey: props.survey
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({survey: nextProps.survey})
  }


  /**
   * Handle changes from fields and assign to the state object
   *
   * @param survey
   * @param key
   * @param value
   */
  handleChange = (survey, key, value) => {
    set(survey, key, value)
    this.setState({survey})
  };


  handleSubmit = () => {
    const submit = this.props.onSubmit(this.state.survey)
    this.setState({submit})

    return submit
  };


  render() {
    const idNamespace = id("survey-form", this.props)
    const hasSpecifiedTeams = (get(this.state.survey, TEAMS_ID_PROPERTY, []) || []).length > 0
    const includeDriverComment = get(this.state.survey, INCLUDE_DRIVER_COMMENT_PROPERTY, false) || false
    const includeActionBoard = get(this.state.survey, INCLUDE_ACTION_BOARD_PROPERTY, false) || false

    return (
      <Form id={idNamespace}>
        <StyledCard>
          <Row>
            <Col>
              <Reference survey={this.state.survey} onChange={this.handleChange} required />
              <Tenant survey={this.state.survey} onChange={this.handleChange} required />
              <QuestionCount survey={this.state.survey} onChange={this.handleChange} required />
              <Status survey={this.state.survey} onChange={this.handleChange} required />
              <TeamsIds survey={this.state.survey} onChange={this.handleChange} />
            </Col>
          </Row>

          <Row>
            <Col>
              <IncludeENPS survey={this.state.survey} onChange={this.handleChange} />
            </Col>
          </Row>

          <Row>
            <Col>
              <IncludeDriverComment survey={this.state.survey} onChange={this.handleChange} />
              {includeDriverComment && <DriverCommentTitle survey={this.state.survey} onChange={this.handleChange} />}
            </Col>
          </Row>

          <Row>
            <Col>
              <IncludeActionBoard survey={this.state.survey} onChange={this.handleChange} />
              {includeActionBoard && <ActionBoardUrl survey={this.state.survey} onChange={this.handleChange} />}
            </Col>
          </Row>
        </StyledCard>

        <Confirm
          id={idNamespace}
          active={!hasSpecifiedTeams}
          confirmText="You haven't specified any teams, this will send the survey to all employees! Continue?">
          <ValidationButtonRouterLink
            async
            primary
            load={this.state.submit}
            onClick={this.handleSubmit}
            id={id("submit-btn", idNamespace)}>
            Submit
          </ValidationButtonRouterLink>
        </Confirm>
      </Form>
    )
  }
}

export default SurveyForm
